<!--
 * @Author: zly
 * @Date: 2024-08-20 19:17:13
 * @LastEditTime: 2024-08-22 14:15:48
 * @LastEditors: 汪俊洪
 * @Description: 单点登录界面
-->
<template>
  <div class="signOn">
    <div class="signOn_box">
      <img class="" src="https://plantmate-prod.oss-cn-hangzhou.aliyuncs.com/front/srm/img/pixiaote_head.gif" alt="" srcset="">
      宁东工业超市平台登录中,请稍后...
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { toStudy } from '@/utils/goStudy.js'
export default {
  data () {
    return {
      // loading: true,
      signInfo: {
        ssoCode: '', // 平台标识 plantmart
        redirectUrl: '', // 重定向地址
        ticket: '', // ticket,
        username: '', // 用户名
        host: '' // 跳转的网页类型
      }
    }
  },
  methods: {
    signOn () {
      this.$http.get(`${window.SITE_CONFIG['apiURL']}/auth/sso/loginByUsername`, { params: this.signInfo })
        .then(({ data: res }) => {
          if (res.code === 0 && res.data) {
            // Cookies.set('access_token_shop', res.data.access_token)
            // Cookies.set('username_shop', res.data.username)
            // 学习平台cookie登录共享
            Cookies.set('access_token_shop', res.data.access_token, {
              domain: location.origin.includes('plantmate.supcon.com') ? '.supcon.com' : '.plantmate.com'
            })
            Cookies.set('username_shop', res.data.username, {
              domain: location.origin.includes('plantmate.supcon.com') ? '.supcon.com' : '.plantmate.com'
            })
            this.bus.$emit('getUserMenuPerm')
            // this.$message.success('登录成功,跳转中...')
            setTimeout(() => {
              // 如果设置了host 跳转其他的网页
              if (this.signInfo.host) {
                toStudy(this.signInfo.redirectUrl)
                return
              }
              this.$router.replace({ path: this.signInfo.redirectUrl })
            }, 300)
          }
        })
        .catch(() => {
        })
    }

  },
  created () {
    this.signInfo.ssoCode = this.$route.query.ssoCode
    this.signInfo.redirectUrl = this.$route.query.redirectUrl
    this.signInfo.ticket = decodeURIComponent(this.$route.query.ticket)
    this.signInfo.username = decodeURIComponent(this.$route.query.username)
    this.signInfo.host = this.$route.query.host
    console.log('host', this.$route.query)

    this.signOn()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.signOn{
  height: 100%;
  .signOn_box{
    width: 220px;
    margin: 180px auto;
    text-align: center;
    img{
      width: 100px;
      height: 100px;
      display: block;
      margin: 0 auto 20px;
    }
  }
}
</style>
